module.exports = "/images/avatar-s-5.jpg?99691e543d9e33cf745f6ac56f5800b8";